<button *ngIf="canShowFavourite()"
    class="px-0 bg-transparent border-0 d-flex flex-column align-content-center justify-content-center text-center"
    [attr.aria-label]="isFavourite ? 'Saved' : 'Save'"
    (click)="handleFavouriteRegistration()">
    <mat-progress-spinner *ngIf="busy" class="spinner black mx-auto" mode="indeterminate" [color]="'#000'"
        [diameter]="24"></mat-progress-spinner>
    <mat-icon data-nosnippet *ngIf="!busy" [ngStyle]="{
        'color': isFavourite ? '#E87676' : '#2f2f2f'
    }" class="d-block mx-auto fs-md-24 fs-mb-20">{{ isFavourite ?
        'favorite' :
        'favorite_border'
        }}</mat-icon>
    <small *ngIf="showText" class="d-none d-md-block fs-md-13 mx-auto">{{ isFavourite ?
        'Saved' :
        (useNew ? 'Save' : 'Favourite')
        }}</small>
</button>

<button *ngIf="canShowNotify()"
    class="px-0 bg-transparent border-0 d-flex flex-column align-content-center justify-content-center text-center"
    [attr.aria-label]="useNew ? (stopArmed ? 'Stop tracking?' : isNotify ? 'Tracking' : 'Track plate') : (isNotify ? 'Notified' : 'Notify')"
    (click)="handleNotifyRegistration()">
    <mat-progress-spinner *ngIf="busy" class="spinner black mx-auto" mode="indeterminate" [color]="'#000'"
        [diameter]="24"></mat-progress-spinner>
    <mat-icon data-nosnippet *ngIf="!busy" [ngStyle]="{
        'color': isNotify ? '#0a6077' : '#2f2f2f'
    }" class="d-block mx-auto fs-md-24 fs-mb-20">{{ useNew ? 'trending_up' : (isNotify ?
        'notifications' :
        'notifications_none')
        }}</mat-icon>
    <small *ngIf="showText" class="d-none d-md-block fs-md-13 mx-auto">{{ useNew ? trackLabel : (isNotify ? 'Notified' : 'Notify')
        }}</small>
</button>
